<template>

<div>
  <nav class="navbar navbar-expand navbar-dark bg-dark">
    <div class="container">
<!--    <a class="navbar-brand" id="nav-principal" href="javascript:void(0);">AMPA</a> -->
      <ul class="navbar-nav mr-auto">
<!--
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="javascript:void(0);" id="selector-curso" role="button" data-toggle="dropdown">
          Curso
        </a>
        <div class="dropdown-menu">
          <a class="dropdown-item" href="javascript:void(0);">2019/20</a>
        </div>
      </li>
-->
        <li class="active" id="nav-atras">
          <a class="nav-link" href="javascript:void(0);" @click="$router.go(-1)">◁</a>
        </li>
        <li class="nav-item" id="nav-familia">
          <router-link to="/" class="nav-link" active-class="active" exact>Familia</router-link>
        </li>
        <template v-if="sesion.admin">
        <li class="nav-item" id="nav-mensajes">
          <router-link to="/admin" class="nav-link">Admin</router-link>
        </li>
        </template>
      </ul>
      <ul class="navbar-nav navbar-right">
        <li class="nav-item pull-right" id="nav-salir">
          <router-link to="/acceso/salir" class="nav-link">Salir</router-link>
        </li>
      </ul>
    </div>
  </nav>

  <div class="container py-3" id="contenido">
    <router-view />
  </div>
</div>

</template>

<script>

import { obtenerSesion } from '../api/api.js';

export default {
	name: 'AreaSocios',
	data () {
		return {
			sesion: null,
		}
	},
	created () {
		this.sesion = obtenerSesion();
		if (! this.sesion) {
			this.$router.push('/acceso');
		}
	}
}
</script>
